import { useContext } from 'react';

import { SelectedEventContext } from 'context/selectedEvent/selectedEventContext/SelectedEventContext';

export const useSelectedInneEvent = () => {
  const context = useContext(SelectedEventContext);

  if (!context) {
    throw new Error('SelectedEventContext is unavailable, make sure you are using SelectedEventContextController');
  }

  return { selectedEvent: context.inneSelectedEvent, setSelectedEvent: context.setInneSelectedEvent };
};
